import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/a4xuApciDBZeojPST7sKJv/cover_1.png';
const BUYERS = [{
  name: 'María G.',
  city: 'Ciudad de México',
  country: 'México'
}, {
  name: 'Ana P.',
  city: 'Bogotá',
  country: 'Colombia'
}, {
  name: 'Carlos R.',
  city: 'Lima',
  country: 'Perú'
}, {
  name: 'Laura M.',
  city: 'Santiago',
  country: 'Chile'
}, {
  name: 'Sofía L.',
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  name: 'Diego S.',
  city: 'Medellín',
  country: 'Colombia'
}, {
  name: 'Valentina C.',
  city: 'Guadalajara',
  country: 'México'
}, {
  name: 'Camila T.',
  city: 'Quito',
  country: 'Ecuador'
}, {
  name: 'Juan D.',
  city: 'Córdoba',
  country: 'Argentina'
}, {
  name: 'Lucía B.',
  city: 'Monterrey',
  country: 'México'
}, {
  name: 'Patricia G.',
  city: 'Asunción',
  country: 'Paraguay'
}, {
  name: 'Roberto M.',
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  name: 'Andrea F.',
  city: 'La Paz',
  country: 'Bolivia'
}, {
  name: 'Fernando H.',
  city: 'San José',
  country: 'Costa Rica'
}, {
  name: 'Gabriela R.',
  city: 'Santo Domingo',
  country: 'Rep. Dominicana'
}];
const TIMES = ['Hace 2 min', 'Hace 5 min', 'Hace 8 min', 'Hace 12 min', 'Hace 15 min', 'Hace unos instantes'];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(BUYERS[0]);
  const [timeAgo, setTimeAgo] = useState(TIMES[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      const randomTime = TIMES[Math.floor(Math.random() * TIMES.length)];
      setBuyer(randomBuyer);
      setTimeAgo(randomTime);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 6000);
    const interval = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-20">
      {visible && <motion.div initial={{
      x: 400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 400,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 right-4 z-40" data-id="element-21">
          <div className="bg-slate-900 rounded-xl shadow-2xl p-3 flex items-center gap-3 border-l-4 border-emerald-500 max-w-xs md:max-w-sm" data-id="element-22">
            <img src={PRODUCT_IMAGE} alt="MegaPack Matemática Lista" className="w-12 h-16 object-contain flex-shrink-0 drop-shadow-md" data-id="element-23" />
            <div className="min-w-0" data-id="element-24">
              <p className="text-sm font-bold text-white truncate" data-id="element-25">
                {buyer.name} de {buyer.city}, {buyer.country}
              </p>
              <p className="text-xs text-slate-400" data-id="element-26">
                compró{' '}
                <span className="font-semibold text-emerald-400" data-id="element-27">
                  MegaPack Matemática Lista™
                </span>
              </p>
              <p className="text-[10px] text-slate-500 mt-0.5" data-id="element-28">{timeAgo}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}